import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'document',
  namespaced: true,
  state: {
    isAddLoading: false,
    fileObj: null,
  },
  getters: {
    getAddLoading(state) {
      return state.isAddLoading
    },
  },
  mutations: {
    setFileObj(state, fileObj) {
      state.fileObj = fileObj
    },
    setAddLoading(state, flag) {
      state.isAddLoading = flag
    },
  },
  actions: {
    /**
     *
     * @param {*} param0
     * @param { key , file}
     * @returns
     */
    async addDocuments({ rootState, getters, commit }, { key, file }) {
      const isLoading = getters.getAddLoading
      if (isLoading) {
        return
      }

      commit('setAddLoading', true)

      try {
        const { data } = await defaultApi.patchDocuments({
          uuid: rootState.auth.info.uuid,
          data: {
            [key]: file,
          },
        })

        return data
      } finally {
        commit('setAddLoading', false)
      }
    },
    async getDocuments({ rootState, commit }) {
      const { data } = await defaultApi.getDocuments({
        uuid: rootState.auth.info.uuid,
      })
      commit('setFileObj', data)
      return data
    },
    async easyLogin() {
      const { data } = await defaultApi.postEasyLogin()
      return data
    },
    async getIssueIncomeCertification({ rootState }, file) {
      const { data } = await defaultApi.postIssueIncomeCertification({
        uuid: rootState.auth.info.uuid,
        file,
      })
      return data
    },
  },
}
